<template>
  <component :is="el" class="sticky"><slot></slot></component>
</template>

<script>

  import Waypoints from 'waypoints/lib/noframework.waypoints.js'
  import 'waypoints/lib/shortcuts/sticky.js'

  export default {
    name: 'sticky',
    props: {
      el: {
        type: String,
        default: "div"
      },
      offset: {
        type: Number
      }
    },
    data () {
      return {
        sticky: null
      }
    },
    mounted () {
      this.sticky = new Waypoint.Sticky({
        element: this.$el,
        offset: this.offset || 0,
      })
    }
  }

</script>

<style>
  .sticky.stuck {
    position:fixed; top:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/_global/sticky.vue